import { DTA_NAVIGATION_ITEMS } from "@dta/utils/constants";
import { E50_NAVIGATION_ITEMS } from "@e50/components/E50Constants";
import { EE_NAVIGATION_ITEMS } from "@ee/utils/constants";
import {
  EVENTS_AWARDS_DTA_PATH,
  EVENTS_AWARDS_E50_PATH,
  EVENTS_AWARDS_EE_PATH,
  EVENTS_AWARDS_SBA_PATH,
  EVENTS_AWARDS_SCA_PATH,
  EVENTS_AWARDS_SIA_PATH,
} from "@events-awards/utils/constants";
import { AwardType } from "@events-awards/utils/types";
import { SBA_NAVIGATION_ITEMS } from "@sba/utils/constants";
import { SCA_NAVIGATION_ITEMS } from "@sca/utils/constants";
import { SIA_NAVIGATION_ITEMS } from "@sia/utils/constants";

/**
 * Returns the URL path for events awards homepage.
 * This function is used to dynamically return the url path based on the award type
 * @param awardType - The type of award.
 * @returns The URL path for the events awards homepage.
 */
export const getHomePageLink = (awardType: string) => {
  switch (awardType) {
    case AwardType.SIA:
      return EVENTS_AWARDS_SIA_PATH;

    case AwardType.SBA:
      return EVENTS_AWARDS_SBA_PATH;

    case AwardType.SCA:
      return EVENTS_AWARDS_SCA_PATH;

    case AwardType.E50:
      return EVENTS_AWARDS_E50_PATH;

    case AwardType.EE:
      return EVENTS_AWARDS_EE_PATH;

    case AwardType.DATA:
      return EVENTS_AWARDS_DTA_PATH;

    default:
      return "/events-awards";
  }
};

/**
 * Returns the navigation constants based on award type.
 * This function is used to dynamically return the navigation items based on the award type
 * @param awardType - The type of award.
 * @returns The navigation constants for the specified award type.
 */
export const getNavigationConstants = (awardType: string) => {
  switch (awardType) {
    case AwardType.SIA:
      return SIA_NAVIGATION_ITEMS;

    case AwardType.SBA:
      return SBA_NAVIGATION_ITEMS;

    case AwardType.SCA:
      return SCA_NAVIGATION_ITEMS;

    case AwardType.E50:
      return E50_NAVIGATION_ITEMS;

    case AwardType.EE:
      return EE_NAVIGATION_ITEMS;

    case AwardType.DATA:
      return DTA_NAVIGATION_ITEMS;
  }
};
